import { useBaseStore, type WebOSName } from '@cometchat/calls-sdk-core';

export function detectOS(): WebOSName {
  if (typeof navigator === 'undefined' || !navigator.userAgent) {
    return 'unknown';
  }

  const ua = navigator.userAgent.toLowerCase();

  if (/android/.test(ua)) return 'android';
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  if (/mac os x/.test(ua)) return 'macos';
  if (/win/.test(ua)) return 'windows';
  if (/linux/.test(ua)) return 'linux';

  return 'unknown';
}

export function isMobileBrowser() {
  const os = detectOS();
  return os === 'android' || os === 'ios';
}

useBaseStore.setState({
  webOSName: detectOS(),
  isMobileBrowser: isMobileBrowser(),
});
